// @flow

import * as React from 'react'

export default class extends React.PureComponent<{}> {
  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/NotSupport.js